import onReady from '../utils/onReady';

/**
 * Boilerplate class demonstrating basic construction.
 * You can expand from here, or find verbose examples in example.js.
 *
 * @param {HTMLElement} container
 * @constructor
 */
class TextBlockFolding {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));

        // You can put other initializer-code here if it isn't dependent on the DOM in any way.
    }

    attachEventListeners() {
        if(this.dom.read_more_btn) {
             this.dom.read_more_btn.addEventListener("click", (event) => {
                this.showFullTextBlock(event);
            });
        }
        if(this.dom.read_less_btn) {
             this.dom.read_less_btn.addEventListener("click", (event) => {
                this.showExcerptBlock(event);
            });
        }
    }

    showFullTextBlock(e) {
        e.preventDefault();
        this.dom.excerpt.style.display = "none";
        this.dom.full_text.style.display = "block";
    }

    showExcerptBlock(e) {
        e.preventDefault();
        this.dom.full_text.style.display = "none";
        this.dom.excerpt.style.display = "block";
    }

    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container,
            excerpt: container.querySelector(".text-block__excerpt"),
            full_text: container.querySelector(".text-block__full-text"),
            read_more_btn: container.querySelector(".ribbon--read-more-btn"),
            read_less_btn: container.querySelector(".ribbon--read-less-btn")
        };

        this.attachEventListeners();


    }

}


export default TextBlockFolding;